import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { DialogOverviewExampleDialogComponent } from '../../dialog-overview-example-dialog/dialog-overview-example-dialog.component';
import { CommonModule } from '@angular/common';
import { MatMenu, MatMenuModule } from '@angular/material/menu';
import { MatToolbar } from '@angular/material/toolbar';

// import { BackendApiService } from '../../../services/backend-api.service';

@Component({
  selector: 'app-site-and-group',
  templateUrl: './site-and-group.component.html',
  styleUrls: ['./site-and-group.component.scss'],
  standalone:true,
  imports: [CommonModule,MatMenu,MatMenuModule,MatToolbar]
})
export class SiteAndGroupComponent implements OnInit {
  pid: boolean;
  showList: boolean;
  emptyMsg: boolean;
  checked = false;

  clientList = [
    {
      id: 11,
      site_name: 'Room 123',
      group_count: '3',
      assets: 5,
      devices:6,
      checked:false,
      users:2
    }
  ]

  public selectValueArr = [];

  breadcrumbsArray: any = [
   "manager-client-list",
    "manager-users-site-group"
  ];

  constructor(public router: Router, private activeRoute: ActivatedRoute, public dialog: MatDialog) {
    this.clientList;
    activeRoute.queryParams.subscribe(params => {
      this.pid = params['clientName'];
        // this.breadcrumbsArray.push(this.pid);
        // this.breadcrumbsArray.sort();
    });
  }

  showGroupList() {
    this.router.navigate(["manager-group-list"]);
  }


  showAssetsList(){
    this.router.navigate(["manager-assets"]);
  }



  goToPageLink(name: string) {
    this.router.navigate([name]);
  }

  selectListItem(index: number, userid: number) {
    if (this.selectValueArr.length == 0) {
      this.selectValueArr.push(userid);
      for (var i = 0; i < this.clientList.length; i++) {
        if (this.clientList[i].id === userid) {
          this.clientList[i].checked = true;
        }
      }
    } else {
      for (var i = 0; i < this.selectValueArr.length; i++) {
        if (this.selectValueArr[i] === userid) {
          this.selectValueArr.splice(i, 1);
          for (var i = 0; i < this.clientList.length; i++) {
            if (this.clientList[i].id === userid) {
              this.clientList[i].checked = false;
            }
          }
        } else {
          this.selectValueArr.push(userid);
          for (var i = 0; i < this.clientList.length; i++) {
            if (this.clientList[i].id === userid) {
              this.clientList[i].checked = true;
            }
          }
        }
      }
    }
  }

  ngOnInit() { }

  async addClients() {
    this.router.navigate(['/manager-site-group']);
  }

  editSiteGroup() {
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        clientName: this.pid,
        pageRef: 'edit-site'
      }
    };
    this.router.navigate(['/manager-site-group'], navigationExtras);
  }


  showListOfUsers() {
      const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
        width: '650px',
        data: {
          type: "managerClientSiteGroup",
        }
        
      });
  }

}
